<template>
    <div>
        <!--
            BLOCO G — itens 30, 31 e 70: resultados das avaliações externas da escola e
            a evolução ao longo dos anos.

            O gráfico usa a stack já presente no projeto (@/chart/BarChart.js, o mesmo de
            evolucao-aluno e tabulacao). Nenhuma média é calculada aqui: a série e a média
            da rede vêm de `resultado-avaliacao-externa/relatorio`.
        -->
        <el-alert type="info" :closable="false" class="u-mb-15"
            title="Lance aqui o resultado de cada avaliação externa por ano."
            description="O catálogo de avaliações (SAEB, IDEB, ANA...) fica em Cadastros Auxiliares › Avaliações Externas."></el-alert>

        <el-row :gutter="10" class="u-mb-15">
            <el-col :xs="24" :sm="16">
                <el-select v-model="filtroAvaliacao" clearable placeholder="Filtrar por avaliação"
                    style="width: 100%;" @change="carregar">
                    <el-option v-for="a in avaliacoes" :key="a.id" :value="a.id"
                        :label="(a.sigla ? a.sigla + ' — ' : '') + a.nome"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="8" class="u-text-right">
                <el-button v-if="podeEscrever" size="small" icon="el-icon-plus" @click="adicionar">ADICIONAR ANO</el-button>
                <el-button class="u-ml-10" v-if="podeEscrever" size="small" type="primary" icon="el-icon-check" @click="salvar">SALVAR</el-button>
            </el-col>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Avaliação</th>
                        <th style="width: 100px;">Ano</th>
                        <th style="width: 150px;">Etapa/Curso</th>
                        <th style="width: 110px;" class="u-text-center">Nota</th>
                        <th style="width: 110px;" class="u-text-center">Meta</th>
                        <th style="width: 100px;" class="u-text-center">Saldo</th>
                        <th style="width: 110px;" class="u-text-center">Participantes</th>
                        <th style="width: 60px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(r, i) in itens" :key="i">
                        <td>
                            <el-select v-model="r.avaliacao_externa_id" size="mini" filterable style="width: 100%;">
                                <el-option v-for="a in avaliacoes" :key="a.id" :value="a.id"
                                    :label="(a.sigla ? a.sigla + ' — ' : '') + a.nome"></el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="r.ano_aplicacao" :min="1990" :max="anoMaximo" size="mini"
                                controls-position="right" style="width: 100%;"></el-input-number>
                        </td>
                        <td>
                            <el-select v-model="r.curso_id" size="mini" clearable filterable style="width: 100%;"
                                placeholder="Escola toda">
                                <el-option v-for="c in cursos" :key="c.id" :value="c.id" :label="c.nome"></el-option>
                            </el-select>
                        </td>
                        <td><el-input-number v-model="r.nota_obtida" :min="0" :precision="2" :step="0.1" size="mini" controls-position="right" style="width: 100%;"></el-input-number></td>
                        <td><el-input-number v-model="r.meta" :min="0" :precision="2" :step="0.1" size="mini" controls-position="right" style="width: 100%;"></el-input-number></td>
                        <td class="u-text-center">
                            <el-tag v-if="saldo(r) === null" size="mini" type="info">—</el-tag>
                            <el-tag v-else-if="saldo(r) < 0" size="mini" type="danger">{{ saldo(r).toFixed(2) }}</el-tag>
                            <el-tag v-else size="mini" type="success">+{{ saldo(r).toFixed(2) }}</el-tag>
                        </td>
                        <td><el-input-number v-model="r.qtd_participantes" :min="0" size="mini" controls-position="right" style="width: 100%;"></el-input-number></td>
                        <td class="u-text-center">
                            <el-button v-if="podeEscrever && r.id" type="text" icon="el-icon-delete" @click="excluir(r)"></el-button>
                            <el-button class="u-ml-10" v-else-if="podeEscrever" type="text" icon="el-icon-close" @click="itens.splice(i, 1)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="itens.length === 0"><td colspan="8" class="u-text-center">Nenhum resultado lançado.</td></tr>
                </tbody>
            </table>
        </div>

        <!-- ==================== ITEM 31 — EVOLUÇÃO ==================== -->
        <h4 class="u-mt-25 u-mb-10">Evolução por ano</h4>

        <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" :sm="12">
                <el-select v-model="avaliacaoGrafico" clearable placeholder="Avaliação a comparar"
                    style="width: 100%;" size="small" @change="carregarEvolucao">
                    <el-option v-for="a in avaliacoes" :key="a.id" :value="a.id"
                        :label="(a.sigla ? a.sigla + ' — ' : '') + a.nome"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="6">
                <el-checkbox v-model="compararRede" @change="carregarEvolucao">Comparar com a rede</el-checkbox>
            </el-col>
        </el-row>

        <div v-if="evolucao && evolucao.anos.length">
            <bar-chart :chart-data="dadosGrafico" :height="300"></bar-chart>
            <small class="u-text-muted">{{ evolucao.observacao }}</small>
        </div>
        <el-alert v-else type="info" :closable="false"
            title="Selecione uma avaliação com resultados lançados para ver a evolução."></el-alert>
    </div>
</template>
<script>
import BarChart from '@/chart/BarChart.js'

/** BLOCO G — itens 30, 31 e 70. */
export default {
    components: { BarChart },
    props: {
        instituicaoId: { type: [Number, String], required: true }
    },
    data: () => ({
        avaliacoes: [], cursos: [], itens: [],
        filtroAvaliacao: null, avaliacaoGrafico: null, compararRede: true, evolucao: null
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        anoMaximo () { return new Date().getFullYear() + 1 },
        dadosGrafico () {
            if (!this.evolucao) return { labels: [], datasets: [] }

            const cores = ['#409EFF', '#67C23A', '#E6A23C', '#8E44AD', '#16A085', '#C0392B']
            const datasets = this.evolucao.series
                .filter(s => parseInt(s.instituicao_id) === parseInt(this.instituicaoId) || this.compararRede)
                .map((s, i) => ({
                    label: s.nome,
                    backgroundColor: cores[i % cores.length],
                    data: s.valores
                }))

            if (this.compararRede) {
                datasets.push({
                    label: 'Média da rede',
                    backgroundColor: '#909399',
                    data: this.evolucao.media_rede
                })
            }

            return { labels: this.evolucao.anos, datasets: datasets }
        }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/resultado-avaliacao-externa/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            this.avaliacoes = (r.data && r.data.avaliacoes) ? r.data.avaliacoes : []
            this.cursos = (r.data && r.data.cursos) ? r.data.cursos : []
        }).catch(e => this.$store.commit('throwException', e))

        this.carregar()
    },
    methods: {
        carregar () {
            const base = `${this.$store.state.config.baseUrlApi}/api/resultado-avaliacao-externa/getByInstituicao/${this.instituicaoId}`
            const cfg = JSON.parse(JSON.stringify(this.$store.getters.getHeaderAuth))
            cfg.params = this.filtroAvaliacao ? { avaliacao_externa_id: this.filtroAvaliacao } : {}

            this.$axios.get(base, cfg).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.itens = (r.data.itens || []).map(i => ({
                    id: i.id,
                    avaliacao_externa_id: i.avaliacao_externa_id,
                    ano_aplicacao: i.ano_aplicacao,
                    curso_id: i.curso_id,
                    nota_obtida: i.nota_obtida !== null ? parseFloat(i.nota_obtida) : null,
                    meta: i.meta !== null ? parseFloat(i.meta) : null,
                    qtd_participantes: i.qtd_participantes
                }))
            }).catch(e => this.$store.commit('throwException', e))
        },
        /** Prévia visual. O saldo persistido é calculado pelo backend. */
        saldo (r) {
            if (r.nota_obtida === null || r.meta === null || r.nota_obtida === undefined || r.meta === undefined) return null
            return r.nota_obtida - r.meta
        },
        adicionar () {
            this.itens.push({ id: null, avaliacao_externa_id: this.filtroAvaliacao || null,
                ano_aplicacao: new Date().getFullYear(), curso_id: null,
                nota_obtida: null, meta: null, qtd_participantes: null })
        },
        salvar () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/resultado-avaliacao-externa/salvarLote`,
                { instituicao_id: this.instituicaoId, itens: this.itens }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem || 'Resultados salvos.', type: 'success' })
                this.carregar()
                this.carregarEvolucao()
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluir (r) {
            this.$confirm('Excluir este resultado?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/resultado-avaliacao-externa/delete/${r.id}`,
                    this.$store.getters.getHeaderAuth
                ).then(res => {
                    if (res.data && res.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(res.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Resultado excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        carregarEvolucao () {
            this.evolucao = null
            if (!this.avaliacaoGrafico) return

            const url = this.compararRede
                ? `${this.$store.state.config.baseUrlApi}/api/resultado-avaliacao-externa/relatorio`
                : `${this.$store.state.config.baseUrlApi}/api/resultado-avaliacao-externa/relatorio/${this.instituicaoId}`

            this.$axios.post(url, { avaliacao_externa_id: this.avaliacaoGrafico },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.evolucao = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
